export default __webpack_public_path__ + "static/media/240.05f20034.png";